import { swRequest } from "@sourcewhale/core";

export const sendSms = (body) =>
  swRequest({
    path: "/api/sms/send",
    method: "POST",
    body,
  });
